import { render, staticRenderFns } from "./StudyPlan.vue?vue&type=template&id=7336d074&scoped=true"
import script from "./StudyPlan.vue?vue&type=script&lang=js"
export * from "./StudyPlan.vue?vue&type=script&lang=js"
import style0 from "./StudyPlan.vue?vue&type=style&index=0&id=7336d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336d074",
  null
  
)

export default component.exports